import { render, staticRenderFns } from "./SalaryEmployees.vue?vue&type=template&id=76a79d0c"
import script from "./SalaryEmployees.vue?vue&type=script&lang=js"
export * from "./SalaryEmployees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports